// import { fetchToken } from "../common/FetchCookie"
// import { ADMIN, ADMIN_RESUME_BUILDER, BASE_URL } from "../common/URLs"

import { fetchToken } from "../../common/FetchCookie"
import { ADMIN, ADMIN_RESUME_BUILDER, BASE_URL } from "../../common/URLs"

export const fetchAdminResumeBuilders = async () => {
    const url = `${BASE_URL}/${ADMIN}/${ADMIN_RESUME_BUILDER}`
    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
        const data = await response.json()
        return data
    } catch (error) {
        console.log("error", error)
        throw error
    }
}

export const addAdminResumeBuilder = async (resumeBuilderData) => {
    const url = `${BASE_URL}/${ADMIN}/${ADMIN_RESUME_BUILDER}`
    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(resumeBuilderData),
        })
        const data = await response.json()
        return data
    } catch (error) {
        console.log("error", error)
        throw error
    }
}

export const updateAdminResumeBuilder = async (updateData) => {
    const { uuid, resumeBuilderData } = updateData
    const url = `${BASE_URL}/${ADMIN}/${ADMIN_RESUME_BUILDER}/${uuid}`
    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "PUT",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(resumeBuilderData),
        })
        const data = await response.json()
        return data
    } catch (error) {
        console.log("error", error)
        throw error
    }
}

export const deleteAdminResumeBuilder = async (uuid) => {
    const url = `${BASE_URL}/${ADMIN}/${ADMIN_RESUME_BUILDER}/${uuid}`
    try {
        const token = await fetchToken()
        const response = await fetch(url, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                Authorization: `Bearer ${token}`,
            },
        })
        const data = await response.json()
        return data
    } catch (error) {
        console.log("error", error)
        throw error
    }
}
